// The offer agent's note on a quote revision (spec 09 §2.13 and §4.4, D-516
// ruling 4, D-546 ruling 4): its own words about the draft, at most 500
// characters, with the locale the gate recorded. `GET /v1/quotes/{id}` serves
// both as optional fields of the revision (spec 09 §5's detail row, additive).
//
// The revision is read as a plain record, so the composer reads the fields
// whether or not the generated client in this tree names them yet, and a
// revision a person wrote (no note) reads as none. A note that is empty or
// only spaces reads as none too: the handler stores no note for one, and a
// frame around nothing would only say the agent wrote something it did not.

export interface AgentNote {
  readonly text: string;
  /** BCP 47 tag the gate recorded with the note, when it is a usable one. */
  readonly locale: string | undefined;
}

/** The shapes the gate and the database accept (0105, 0106). */
const LOCALE_RE = /^[a-z]{2}(-[A-Za-z]{2,4})?$/u;

export function revisionAgentNote(revision: object | undefined): AgentNote | undefined {
  if (revision === undefined) return undefined;
  const record = revision as Readonly<Record<string, unknown>>;
  const text = record["agent_note"];
  if (typeof text !== "string" || text.trim().length === 0) return undefined;
  const locale = record["agent_note_locale"];
  return {
    text,
    locale: typeof locale === "string" && LOCALE_RE.test(locale) ? locale : undefined,
  };
}
